import { render, staticRenderFns } from "./ClosedQuestion.vue?vue&type=template&id=124a89f6&scoped=true&lang=pug&"
import script from "./ClosedQuestion.vue?vue&type=script&lang=js&"
export * from "./ClosedQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ClosedQuestion.vue?vue&type=style&index=0&id=124a89f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a89f6",
  null
  
)

export default component.exports